import { render, staticRenderFns } from "./WordsManage.vue?vue&type=template&id=7ce4ba14&"
import script from "./WordsManage.vue?vue&type=script&lang=js&"
export * from "./WordsManage.vue?vue&type=script&lang=js&"
import style0 from "./WordsManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports